module.exports = __webpack_public_path__ + "static/media/date_ic.403d62ef.svg";